import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../Button';
export function AboutCta() {
  const reduce = useReducedMotion();
  const navigate = useNavigate();
  return <section className="w-full bg-white" data-id="element-18" data-mp="297cut3t2d6kq">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20" data-id="element-19" data-mp="257c7etnzll1j">
        <motion.div initial={reduce ? undefined : {
        opacity: 0,
        y: 18
      }} whileInView={reduce ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="rounded-2xl bg-deep-navy px-6 py-12 text-center sm:px-12" style={{
        backgroundColor: '#0F4C81'
      }} data-id="element-20" data-mp="256140uygefay">
          <h2 className="font-heading text-2xl font-bold text-white sm:text-3xl" data-id="element-21" data-mp="2o1jpctwiytni">
            まずは、あなたの現場の困りごとを聞かせてください。
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-white/80" data-id="element-22" data-mp="2szuvatjp8k0g">
            現在、新規の無料体験・無料デモの受付は一時停止しています。伴走支援やサービス内容についてのお問い合わせは、こちらからお寄せください。
          </p>
          <div className="mt-8 flex justify-center" data-id="element-23" data-mp="32qxyq203pb2w">
            <Button variant="secondary" size="lg" onClick={() => navigate('/#contact')} data-id="element-24" data-mp="253yzbji0xp1b">
              お問い合わせ
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}